import { PRODUCTION, DEVELOPMENT, LOCAL_PRODUCT_MASTER_URL } from "./const";
import { isEmpty } from "lodash";

export function productMasterURL() {
  const REACT_ENV = process.env.NODE_ENV;
  const PRODUCT_MASTER_URL = !!process.env.REACT_APP_PRODUCT_MASTER_URL && process.env.REACT_APP_PRODUCT_MASTER_URL !== "" ? process.env.REACT_APP_PRODUCT_MASTER_URL : "";
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return LOCAL_PRODUCT_MASTER_URL;
      case PRODUCTION:
        return PRODUCT_MASTER_URL;
      default:
        return LOCAL_PRODUCT_MASTER_URL;
    }
  } else {
    return LOCAL_PRODUCT_MASTER_URL;
  }
}

export const getProductMasterURL = () => {
  return `${productMasterURL()}`;
};
